import { User } from "@budibase/types"
import { users } from "@budibase/backend-core"
import * as features from "../features"
import * as quotas from "../quotas"
import * as groups from "../groups"

users.UserDB.init(quotas, groups, features)
export const db = users.UserDB

export async function addAppBuilder(user: User, appId: string) {
  if (!(await features.isAppBuildersEnabled())) {
    throw new Error("Feature not enabled, please check license")
  }
  await users.addAppBuilder(user, appId)
}

export async function removeAppBuilder(user: User, appId: string) {
  if (!(await features.isAppBuildersEnabled())) {
    throw new Error("Feature not enabled, please check license")
  }
  await users.removeAppBuilder(user, appId)
}
